import { render, staticRenderFns } from "./verification_level_token.vue?vue&type=template&id=12988327"
import script from "./verification_level_token.vue?vue&type=script&lang=js"
export * from "./verification_level_token.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports